import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DOCUMENTS_AND_JOBS_KEY } from '../../../../contracts';
import { retryJob } from '../api';

/**
 * Hook to retry a failed job.
 * Invalidates the documents list on success to show updated status.
 */
export function useRetryJob() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retryJob,
    onSuccess: () => {
      // Invalidate to refetch and show the job back in pending state
      void queryClient.invalidateQueries({ queryKey: [DOCUMENTS_AND_JOBS_KEY] });
    },
  });
}
